// import ClientMonitor from 'skywalking-client-js';
import { publicService } from '@/api/';
import dayjs from 'dayjs';
import { getKey } from './authkey';
import { useUserStore } from '@/store';
import { tools } from './tools';
const modeLists = ['production', 'pc2', 'matrixProd', 'kaixian'];
// 这个错误忽略
const ignoreMsg = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
  'CanceledError: canceled',
  'AxiosError: 网络异常，请刷新后重试 （502）',
  'TypeError: CanceledError: canceled',
  't.target.className.indexOf is not a function',
  'TypeError: t.target.className.indexOf is not a function', // vueTree组件错误
  'Script error.',
  'INVALID_STATE_ERROR: Invalid status: 8', // 传显科技外呼问题
  'INVALID_STATE_ERROR: Invalid status: 9', // 传显科技外呼问题
  'TypeError: Reduce of empty array with no initial value', // 疑似tdesign组件问题
  'Global JavaScript Error: Uncaught TypeError: Cannot read properties of undefined (reading', // tdesign table 组件问题
  'Error: [object Object]' // 飞书sdk问题
];
// 这个错误需要给内部群发消息
// const ignoreSendMsg = [
//   'TypeError: Reduce of empty array with no initial value',
//   'Global JavaScript Error: Uncaught TypeError: Cannot read properties of undefined (reading', // tdesign table 组件问题
//   'INVALID_STATE_ERROR: Invalid status: 8', // 传显科技外呼问题
//   'INVALID_STATE_ERROR: Invalid status: 9' // 传显科技外呼问题
// ];
// 这个错误也忽略，这个错误是错误信息的一部分
const errorsMsgs = ["Cannot read properties of null (reading 'dispatchEvent')", 'Failed to fetch dynamically imported module', 'Unable to preload CSS for', 'Cannot resolve a Slate point from DOM point', 'Cannot resolve a DOM point from Slate point', 'Uncaught INVALID_STATE_ERROR: Invalid status:', 'error loading dynamically imported module'];
console.log(88888, tools.getWindowNavigator(), import.meta.env);
export default function (app, options = {}) {
  const mode = import.meta.env.MODE;
  const service = options.service || `FE_instance_${mode}`;
  const serviceVersion = options.serviceVersion || '1.0.0';
  console.log(155555, mode === 'dev' && import.meta.env.VITE_devmsg === '1');
  if (modeLists.includes(mode) || (mode === 'dev' && import.meta.env.VITE_devmsg === '1')) {
    // skyWalking
    // ClientMonitor.register({
    //   // 基础配置
    //   collector: window.location.origin + '/sky',
    //   service,
    //   serviceVersion,
    //   pagePath: window.location.href,
    //   jsErrors: options.jsErrors !== false,
    //   apiErrors: options.apiErrors !== false,
    //   resourceErrors: options.resourceErrors !== false,
    //   vue: options.vue !== false
    // });
    const errorHandler = (error, instance, info) => {
      console.log(22234344, 'errorHandler', error, instance, info);
      handleError(error, instance, info, service, serviceVersion, null, error);
    };

    app.config.errorHandler = errorHandler;

    const jsError = function (message, source, lineno, colno, error) {
      console.log(22234344, 'jsError');
      // 格式化错误信息
      const errorMessage = `Global JavaScript Error: ${message}\nSource: ${source}\nLine: ${lineno}\nColumn: ${colno}`;
      handleError(message, null, null, service, serviceVersion, errorMessage, error);
      // 返回 true 表示你已经处理了错误，浏览器不会显示默认的错误对话框
      // return true;
    };

    window.onerror = jsError;
  }
}
async function handleError(message, instance, info, service, serviceVersion, customErrorMessage = null, error = null) {
  console.log(2223434567890, message, instance, info, service, serviceVersion, customErrorMessage, error);
  const errorMessage = customErrorMessage || `Vue Error: ${message}`;
  // const mode = import.meta.env.MODE;
  // if (ClientMonitor && ClientMonitor.catchErrors) {
  const errInfo = {
    collector: window.location.origin + '/sky',
    service,
    serviceVersion,
    pagePath: location.href,
    message,
    error: errorMessage,
    stack: error ? error.stack : '',
    vueComponent: instance ? instance.$options?.name || 'unknown' : 'unknown',
    info
  };
  // ClientMonitor.catchErrors(errInfo);
  // 不同环境不同的处理
  await sendMsg(errInfo, message);
  // } else {
  //   // 如果 SkyWalking 客户端不可用，则可以选择其他上报方式，比如发送到你的后端服务
  //   console.error('SkyWalking ClientMonitor is not available, error cannot be reported to SkyWalking.');
  //   //...其他上报逻辑
  // }
}
// 调用api发送消息
const sendMsg = async (errInfo, message) => {
  console.log(222343442, '发送一个后端api开始', errInfo.error);
  const mode = import.meta.env.MODE;
  const userStore = useUserStore();
  try {
    const { key, skey } = getKey();
    const headerBg = 'red';
    const headerBgObj = {
      dev: 'blue',
      kaixian: 'orange'
    };
    const params = {
      msg_type: 'interactive',
      card: {
        config: {
          update_multi: true
        },
        i18n_elements: {
          zh_cn: [
            {
              tag: 'markdown',
              content: `**ErrorInfo：**\n${errInfo?.error}`,
              text_align: 'left',
              text_size: 'normal'
            },
            {
              tag: 'markdown',
              content: `**Stack：**\n${errInfo?.stack}`,
              text_align: 'left',
              text_size: 'normal'
            },
            {
              tag: 'markdown',
              content: `**vueComponent: **\n${errInfo.vueComponent}`,
              text_align: 'left',
              text_size: 'normal'
            },
            {
              tag: 'markdown',
              content: `**访问页面: **\n${window.location.href}`,
              text_align: 'left',
              text_size: 'normal'
            },
            {
              tag: 'markdown',
              content: `**设备信息 **\n${JSON.stringify(tools.getWindowNavigator())}`,
              text_align: 'left',
              text_size: 'normal'
            },
            {
              tag: 'column_set',
              flex_mode: 'none',
              columns: [
                {
                  tag: 'column',
                  width: 'weighted',
                  vertical_align: 'top',
                  elements: [
                    {
                      tag: 'markdown',
                      content: `**🗳租户key：**\n${key} + ${skey} \n租户：${userStore.userInfo?.orgName || '-'}`,
                      text_align: 'left'
                    }
                  ],
                  weight: 1
                },
                {
                  tag: 'column',
                  width: 'weighted',
                  vertical_align: 'top',
                  elements: [
                    {
                      tag: 'markdown',
                      content: `**📝使用者：**\n${userStore.userInfo?.userName || '未知'}(${userStore.userInfo?.id || '-'}) \n租户Id：${userStore.userInfo?.orgId || '0'}`,
                      text_align: 'left'
                    }
                  ],
                  weight: 1
                }
              ],
              margin: '16px 0px 0px 0px'
            }
          ]
        },
        i18n_header: {
          zh_cn: {
            title: {
              tag: 'plain_text',
              content: `【问题来了】-${mode}-${errInfo.error}`
            },
            subtitle: {
              tag: 'plain_text',
              content: `时间：${dayjs().format('YYYY-MM-DD HH:mm:ss')}`
            },
            template: headerBgObj[mode] || headerBg
          }
        }
      }
    };
    // 线上环境
    console.log(1733333, ['dev'].includes('dev'), ignoreMsg, `${message}`, ignoreMsg.includes(`${message}`));
    if (modeLists.includes(mode)) {
      const hasError = errorsMsgs.some((err) => message.includes(err));
      if (!ignoreMsg.includes(`${message}`) && !hasError) {
        await publicService.sendFeiShuHookMsg(params);
      }
    }
    // 测试环境
    if (mode === 'dev' && import.meta.env.VITE_devmsg === '1') {
      await publicService.sendFeiShuFeMsg(params);
    }
  } catch (e) {
    console.log(222343443, '发送一个后端api结束', e);
  }
};

export const performance = () => {
  // const mode = import.meta.env.MODE;
  // const service = `FE_instance_${mode}`;
  // const serviceVersion = '1.0.0';
  // ClientMonitor.setPerformance({
  //   collector: window.location.origin + '/sky',
  //   service,
  //   serviceVersion,
  //   pagePath: location.href,
  //   useFmp: true,
  //   vue: 'Vue'
  // });
};

export const catchError = (error) => {
  console.log(error);
  // const mode = import.meta.env.MODE;
  // const service = `FE_instance_${mode}`;
  // const serviceVersion = '1.0.0';
  // const errorMessage = `Error: ${error.toString()}`;
  // ClientMonitor.catchErrors({
  //   collector: window.location.origin + '/sky',
  //   service,
  //   serviceVersion,
  //   pagePath: location.href,
  //   message: error.message,
  //   error: errorMessage,
  //   stack: error ? error.stack : ''
  // });
};
